import QueryString from 'qs'
import { fetchFormValues } from '../../utils/formUtils/forms'
import { apiClient } from '../client'
import { PageListParams } from '../globalTypes'
import { ACTIVITY_VALUE_ENDPOINTS } from './formValuesConfig'
import {
    Activity,
    ActivityCreatePayload,
    ActivityCriteria,
    ActivityDeleteResponse,
    ActivityListResponse,
    ActivityMutationResponse,
    ActivityUpdatePayload,
    ActivityValuesData,
} from './types'

export const getActivityById = async (id: number): Promise<Activity> => {
    const response = await apiClient(`v1/activity/${id}`)

    return response.data
}

export const getActivities = async (params: PageListParams<ActivityCriteria>): Promise<ActivityListResponse> => {
    const { contactId, ...queryParams } = params
    const url = contactId ? `v1/activity/contact/${contactId}` : 'v1/activity'

    const response = await apiClient(url, {
        params: queryParams,
        paramsSerializer: (p: Omit<PageListParams<ActivityCriteria>, 'contactId'>) => QueryString.stringify(p),
    })

    return response.data
}

export const createActivity = async (data: ActivityCreatePayload): Promise<ActivityMutationResponse> => {
    const contactId = data.contact_company_collection?.[0]?.contact_id
    const contact_company_collection = contactId === undefined ? [] : data.contact_company_collection

    const response = await apiClient('v1/activity', {
        method: 'POST',
        data: { ...data, contact_company_collection },
    })

    return response.data
}

export const updateActivity = async (data: ActivityUpdatePayload): Promise<ActivityMutationResponse> => {
    const { id, ...payload } = data

    const response = await apiClient(`v1/activity/${id}`, {
        method: 'PUT',
        data: payload,
    })

    return response.data
}

export const deleteActivity = async (id: number): Promise<ActivityDeleteResponse> => {
    const response = await apiClient(`v1/activity/${id}`, {
        method: 'DELETE',
    })

    return response.data
}

export const fetchActivityValues = () => fetchFormValues<ActivityValuesData>(ACTIVITY_VALUE_ENDPOINTS)
